import { Box3, LineBasicMaterial, LineDashedMaterial, MeshBasicMaterial, MeshLambertMaterial, MeshPhongMaterial,  ShaderMaterial, MeshStandardMaterial } from 'three';
import { HsbVisual } from './hsb-visual';
import { FastenerAssemblyEnt, HsbElement, HsbEntity, MassGroup, MetalPartCollectionEnt, NonHsb, Opening, SceneLayerName, Sheet, TslInst } from './hsbcad-model';
import { MaterialManager } from './modelviewer/Managers/MaterialManager';


export enum HideMode {
    Hide = 0,
    Ghost = 1,
}

/**
 * @deprecated Refrain from using Visual layer.
 */
export class HsbVisualLayer {

    visuals: any;
    hideMode;
    hidematerial;
    ghostmaterial;
    materialManager: MaterialManager;
    displayElementLabels: Boolean;
    activeZones: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    constructor(materialmanager: MaterialManager) {

        this.visuals = {};
        this.hideMode = HideMode.Ghost;
        this.materialManager = materialmanager;
        this.hidematerial = materialmanager.getHidematerial();
        this.ghostmaterial = materialmanager.getGhostmaterial();
        this.displayElementLabels = true;
    }

    addVisual(modelName: string, visual: HsbVisual) {

        if (!visual || !modelName) return;

        if (!this.visuals[modelName]) {
            this.visuals[modelName] = {};
        }

        this.visuals[modelName][visual.entity.handle] = visual;
        visual.visualLayer = this;
    }

    allVisuals(visibleonly = false) {

        let _self = this;
        let allvisuals: any[] = [];

        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual: any = model[entitykey];

                if (visual && (!visibleonly || visual.visible)) {
                    allvisuals.push(visual);
                }
            });
        });

        return allvisuals;
    }

    allHiddenVisuals() {

        let _self = this;
        let allvisuals: any[] = [];

        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual && !visual.visible) {
                    allvisuals.push(visual);
                }
            });
        });

        return allvisuals;
    }

    allSelectedVisuals() {

        let _self = this;
        let allvisuals: any[] = [];

        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual && visual.selected) {
                    allvisuals.push(visual);
                }
            });
        });

        return allvisuals;
    }

    allHighlightedVisuals() {

        let _self = this;
        let allvisuals: any[] = [];

        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual && visual.highlighted) {
                    allvisuals.push(visual);
                }
            });
        });

        return allvisuals;
    }

    allVisualEntities(visible: boolean) {

        let _self = this;
        let entities: HsbEntity[] = [];
        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual && (!visible || (visual.visible && visual.entity))) {
                    entities.push(visual.entity);
                }
            });
        });

        return entities;
    }


    selectAllEntities(select: any) {

        let _self = this;
        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual && visual.visible && !visual.highlighted) {
                    visual.select(select);
                }
            });
        });
    }

    setAllSnap(snap: any) {

        let _self = this;
        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual) {
                    visual.snap = snap;
                }
            });
        });
    }

    setSnap(snap: any, entities: null) {
        let _self = this;
        if (entities != null) {
            let selectedVisuals = _self.getVisuals(entities);
            selectedVisuals?.forEach(visual => {
                visual.snap = snap;
            });
        }
    }

    showElementLabels(show: any) {

        let _self = this;
        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {
                var visual = model[entitykey];
                if (visual && visual.entity && visual.entity instanceof HsbElement) {
                    visual.show(show);
                }
            });
        });
    }

    showAllEntities(show: boolean) {

        let _self = this;
        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual) {

                    visual.hidematerial = _self.hideMode === HideMode.Ghost ? _self.ghostmaterial : _self.hidematerial;
                    visual.show(show);
                    if (visual.entity)
                        visual.entity.visible = show;
                }
            });
        });
    }

    resetAllEntitiesToOriginalMaterial() {

        let _self = this;
        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual && visual.geometryModel) {
                    visual.material = visual.originalmaterial;
                }
            });
        });
    }

    resetEntitiesToOriginalMaterial(entities: any[]) {
        let _self = this;
        entities.forEach((entity: { hsbmodel: { modelId: string | number; }; handle: string | number; }) => {
            let visual = _self.visuals[entity.hsbmodel.modelId][entity.handle];
            if (visual && visual.geometryModel) {
                visual.material = visual.originalmaterial;
            }
        });
    }
    resetVisualsToOriginalMaterial(visuals: any[]) {
        visuals.forEach((visual: { geometryModel: any; material: any; originalmaterial: any; }) => {
            if (visual && visual.geometryModel) {
                visual.material = visual.originalmaterial;
            }
        });
    }
    getVisuals(entities: any[]) {
        if (!entities)
            return null;

        let _self = this;
        let visuals: any[] = [];

        entities.forEach((entity: { hsbmodel: { modelId: string | number; }; handle: string | number; }) => {

            let model = _self.visuals[entity.hsbmodel.modelId];

            if (!model) return;
            let visual = model[entity.handle];

            if (visual) {
                visuals.push(visual);
            }
        });

        return visuals;
    }

    setActiveZones(...zones: number[]) {
        this.activeZones = zones;
    }

    disableZone(...zones: number[]) {
        this.activeZones = this.activeZones.filter((z) => !zones.includes(z));
    }

    enableZone(...zones: number[]) {
        this.activeZones = this.activeZones.concat(zones);
    }

    getZonesInLayer() {
        let _self = this;
        let result: any[] = [];
        Object.keys(this.visuals).forEach(function (drawingname) {
            var model = _self.visuals[drawingname];
            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual && visual.entity.zone && !result.includes(visual.entity.zone)) {
                    result.push(visual.entity.zone);
                }
            });
        });
        return result;
    }

    getVisualsInZone(...zones: number[]) {
        let _self = this;
        let result: any[] = [];
        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = _self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey];

                if (visual && visual.entity.zone && zones.includes(visual.entity.zone)) {
                    result.push(visual);
                }
            });
        });
        return result;
    }

    getVisualsZones(entities: any[], zones: string | any[]) {
        let _self = this;
        let visuals: any[] = [];

        entities.forEach((entity: { zone: any; hsbmodel: { modelId: string | number; }; handle: string | number; }) => {

            if (!entity.zone || !zones.includes(entity.zone)) return;

            let visual = _self.visuals[entity.hsbmodel.modelId][entity.handle];

            if (visual) {
                visuals.push(visual);
            }
        });

        return visuals;
    }

    colorVisuals(materialManager: MaterialManager, visuals: any[], color: string) {

        //let visuals = this.getVisuals(entities);
        var materialId = 'Hsb-Material-' + color;

        let material = materialManager.findMaterial(materialId);
        if (!material) {
            material = materialManager.addNewMaterial(materialId, { color: color });
        }

        visuals.forEach((visual: { color: (arg0: (MeshStandardMaterial | LineBasicMaterial | LineDashedMaterial | MeshLambertMaterial | MeshBasicMaterial | MeshPhongMaterial | ShaderMaterial) | null) => void; }) => {
            visual.color(material);
        });
    }

    getCompoundBoundingBox(visuals: HsbVisual[]): Box3 {
        var box: THREE.Box3 = new Box3().makeEmpty();

        visuals.forEach((visual) => {

            if (!visual.entity) return;

            var addboundingbox = function (visual: HsbVisual) {

                if (visual.geometryModel) {
                    box.expandByObject(visual.geometryModel);
                }
            }

            if (visual.entity instanceof HsbElement) {
                var entities = visual.entity.entities;
                var visuals = HsbVisual.getVisuals(visual.visualLayer, entities);

                if (visuals.length === 0) {
                    addboundingbox(visual);
                }
                visuals.forEach(visual => {
                    addboundingbox(visual);
                });
            } else {
                addboundingbox(visual);
            }
        });

        return box;
    }

    getEntities(visuals: any[]) {
        return visuals.map(function (visual: { entity: any; }) { return visual.entity; });
    }

    setmaterial(materialManager: MaterialManager, visual: { entity: any; material: any; selectmaterial: MeshStandardMaterial; highlightmaterial: MeshStandardMaterial; hidematerial: any; originalmaterial: any; geometryModel: { material: any; materialHsbId: any; }; }, material: any) {

        var entityobject = visual;

        if (visual instanceof HsbVisual) {
            entityobject = visual.entity;
        }
        var objectmaterial = material;

        if (!objectmaterial) {
            objectmaterial = materialManager.getBeamMaterial();

            if (entityobject instanceof Sheet) {
                objectmaterial = materialManager.getSheetMaterial();
            } else if (entityobject instanceof NonHsb) {
                objectmaterial = materialManager.getNonHsbMaterial();
            } else if (entityobject instanceof HsbElement) {
                objectmaterial = materialManager.getGreenmaterial();
            } else if (entityobject instanceof MassGroup ||
                entityobject instanceof TslInst ||
                entityobject instanceof FastenerAssemblyEnt ||
                entityobject instanceof MetalPartCollectionEnt) {
                objectmaterial = materialManager.getMetalpartmaterial();
            }
            else if (entityobject instanceof Opening) {
                objectmaterial = materialManager.getWindowMaterial();
            }
        }

        visual.material = objectmaterial;
        visual.selectmaterial = materialManager.getSelectMaterial();
        visual.highlightmaterial = materialManager.getHighlightMaterial();
        visual.hidematerial = this.hideMode === HideMode.Ghost ? this.ghostmaterial : this.hidematerial;
        visual.hidematerial = this.ghostmaterial;
        visual.originalmaterial = objectmaterial;
        visual.geometryModel.material = objectmaterial;
        visual.geometryModel.materialHsbId = objectmaterial.materialHsbId;
    }

    clone(materialManager: MaterialManager, newVisualLayer: HsbVisualLayer, hideMode: HideMode, entities: any[]) {

        let self = this;
        let visualsAdded: any[] = [];

        Object.keys(this.visuals).forEach(function (drawingname) {

            var model = self.visuals[drawingname];

            Object.keys(model).forEach(function (entitykey) {

                var visual = model[entitykey]
                if (visual && visual.geometryModel) {

                    if (entities) {
                        let found = entities.filter(function (e: any) { return e === visual.entity })[0];
                        if (!found) return;
                    }

                    let newVisual = new HsbVisual();
                    newVisual.entity = visual.entity;
                    newVisual.geometryModel = visual.geometryModel.clone();

                    newVisual.material = visual.material;
                    newVisual.originalmaterial = visual.originalmaterial;
                    newVisual.geometryModel.material = visual.geometryModel.material;
                    newVisual.geometryModel.materialHsbId = visual.geometryModel.materialHsbId;

                    newVisual.selectmaterial = visual.selectmaterial;
                    newVisual.highlightmaterial = visual.highlightmaterial;
                    newVisual.hidematerial = visual.hidematerial;

                    visualsAdded.push(newVisual);
                    newVisualLayer.addVisual(drawingname, newVisual);

                    newVisual.geometryModel.traverse(function (geomobject: { visual: HsbVisual; name: string; originalmaterial: any; }) {

                        
                        if (geomobject.name === SceneLayerName.Label || geomobject.name === SceneLayerName.Arrow) {
                            geomobject.originalmaterial = materialManager.getGreenmaterial();
                        } else if (geomobject.name === SceneLayerName.FactoryEntityLabel) {
                            geomobject.originalmaterial = materialManager.getBlackmaterial();
                        }
                    });
                }
            });
        });

        return visualsAdded;
    }

    getVisualsOffChildren(entity: { node: { children: any; }; }) {
        let visuals = this.getVisuals([entity])
        if (visuals && visuals.length > 0) {
            return visuals;
        }

        let children = entity.node?.children
        let childVisuals: any[] = [];
        if (children && children.length > 0) {
            children.forEach((child: { entity: any; }) => {
                let v = this.getVisualsOffChildren(child.entity);
                if (v && v.length > 0)
                    childVisuals = childVisuals.concat(v);
            });
        }
        return childVisuals;

    }
}
